var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"type":"info","id":"info","icon":"mdi-information"},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.info))])}
var staticRenderFns = []

export { render, staticRenderFns }